/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataSourceResponseUpdated } from '../models/data-source-response-updated';
import { dataSourcesControllerGetDataSources } from '../fn/data-sources-controller/data-sources-controller-get-data-sources';
import { DataSourcesControllerGetDataSources$Params } from '../fn/data-sources-controller/data-sources-controller-get-data-sources';
import { dataSourcesControllerPutDataSource } from '../fn/data-sources-controller/data-sources-controller-put-data-source';
import { DataSourcesControllerPutDataSource$Params } from '../fn/data-sources-controller/data-sources-controller-put-data-source';
import { DataSourcesMetaResponseGetRecordsList } from '../models/data-sources-meta-response-get-records-list';


/**
 * Represents API endpoints for data sources.
 */
@Injectable({ providedIn: 'root' })
export class DataSourcesControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dataSourcesControllerPutDataSource()` */
  static readonly DataSourcesControllerPutDataSourcePath = '/planning-projects/v1/scopes/data-sources/{dataSource}';

  /**
   * Creates or updates a data source with the given name.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataSourcesControllerPutDataSource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataSourcesControllerPutDataSource$Response(params: DataSourcesControllerPutDataSource$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceResponseUpdated>> {
    return dataSourcesControllerPutDataSource(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates or updates a data source with the given name.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataSourcesControllerPutDataSource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataSourcesControllerPutDataSource(params: DataSourcesControllerPutDataSource$Params, context?: HttpContext): Observable<DataSourceResponseUpdated> {
    return this.dataSourcesControllerPutDataSource$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataSourceResponseUpdated>): DataSourceResponseUpdated => r.body)
    );
  }

  /** Path part for operation `dataSourcesControllerGetDataSources()` */
  static readonly DataSourcesControllerGetDataSourcesPath = '/planning-projects/v1/scopes/data-sources';

  /**
   * Provides all data source identifiers with nullable scoped metadata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataSourcesControllerGetDataSources()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataSourcesControllerGetDataSources$Response(params?: DataSourcesControllerGetDataSources$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourcesMetaResponseGetRecordsList>> {
    return dataSourcesControllerGetDataSources(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides all data source identifiers with nullable scoped metadata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataSourcesControllerGetDataSources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataSourcesControllerGetDataSources(params?: DataSourcesControllerGetDataSources$Params, context?: HttpContext): Observable<DataSourcesMetaResponseGetRecordsList> {
    return this.dataSourcesControllerGetDataSources$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataSourcesMetaResponseGetRecordsList>): DataSourcesMetaResponseGetRecordsList => r.body)
    );
  }

}
